import { BehaviorSubject } from "rxjs";
import FormBuilderService from "../services/form-builder.service";
import { FormHelperService } from "./form.helper.service";
import { toast } from "react-toastify";
import { formListService } from "./form-list.service";
import {
  htmlBase64Utils,
  transformFormData,
  translationFormPayloadFormat,
} from "../utility/CommonUtils";
import { fetchSites } from "./api-service";
import { CONDITIONAL_FORM } from "../utility/Constant";

export const FORM_STATUS = Object.freeze({
  DRAFT: "Draft",
  PUBLISHED: "Published",
});

var expandedSectionId = undefined;
var translateSectionId = undefined;
var activeElementId = undefined;
var activeTranslateElementId = undefined;
var currentFormId = undefined;
var currentSubsectionId = undefined;
var translateSubsectionId = undefined;
var errorIds = [];
var sections = undefined;
var sectionArray = undefined;
var subsections = undefined;
var subsectionArray = undefined;
var questionElements = undefined;
var questionArray = undefined;
var currentFormCode = undefined;
var conditionalMenuIndex = -1;
var isDialogOpen = false;
var inputEle = [];
var copyFormRes = {};
var optionalEquipment = "";
var regionArray = [];
var formType = "all";
var previousVersionFormRes = {};
const isMockFlow = false;
const formBuilderService = new FormBuilderService();
const formState = new BehaviorSubject({});
const translateFormState = new BehaviorSubject({});
const loaderState = new BehaviorSubject(false);
const openSectionState = new BehaviorSubject(expandedSectionId);
const openTranslateSectionState = new BehaviorSubject(translateSectionId);
const activeElementState = new BehaviorSubject(activeElementId);
const activeTranslateElementState = new BehaviorSubject(
  activeTranslateElementId,
);
const currentSubsectionState = new BehaviorSubject(currentSubsectionId);
const translateSubsectionState = new BehaviorSubject(translateSubsectionId);
const conditionalMenuState = new BehaviorSubject(conditionalMenuIndex);
const routeState = new BehaviorSubject(false);
const formValidState = new BehaviorSubject(true);
const showAlertState = new BehaviorSubject(false);
const dialogState = new BehaviorSubject(isDialogOpen);
const sideTocState = new BehaviorSubject(false);
const activeTocElementState = new BehaviorSubject(undefined);
const publishedFormState = new BehaviorSubject(true);
const copyResponseState = new BehaviorSubject(copyFormRes);
const optionalEquipmentState = new BehaviorSubject(optionalEquipment);
const siteArrayState = new BehaviorSubject([]);
const loggedInState = new BehaviorSubject(false);
const parentDropDownId = new BehaviorSubject("");
const formTypeState = new BehaviorSubject(formType);
const isConditionalFormState = new BehaviorSubject(false);
const formUniversalTaggedState = new BehaviorSubject(false);
const previousVersionResponseState = new BehaviorSubject(previousVersionFormRes);

const getInitialFormDetails = () => ({
  title: "",
  description: "",
  keywords: [],
  business: "",
  subbusiness: "",
  group: "",
  subgroup: "",
  language: "en",
  groupIds: [],
  formRegion: [],
  formSiteRegion: [],
});

class FormStore {
  static _instance = null;

  constructor() {
    this.form = {};
    this.initialForm = {};
    this.translateForm = {};
    this.formDetails = getInitialFormDetails();
  }

  static sharedInstance() {
    if (FormStore._instance == null) {
      FormStore._instance = new FormStore();
    }

    return this._instance;
  }

  copyForm = async (formId) => {
    currentFormId = formId;
    this.resetState();
    await formBuilderService.getForm(formId).then((res) => {
      const formDetails = { ...res.data, title: `Copy of ${res.data.title}` };
      this.form = formDetails;
      this.initialForm = formDetails;
      formState.next(formDetails);
    });
  };

  deleteForm = (formId) => {
    this.onLoading(true);
    formBuilderService.deleteForm(formId).then((res) => {
      this.onLoading(false);
      if (res.status !== 200) {
        toast.error("Could not delete form, " + res.message);
        return;
      }
      formListService.fireApi();
      toast.success("Form deleted successfully!");
    });
  };

  getPreviousVersionFormResponse = (previousVersionFormRes) => {
    previousVersionResponseState.next(previousVersionFormRes);
  };

  previousVersionFormData = async (formCode) => {
    currentFormCode = formCode;
    this.onLoading(true);
    formBuilderService.getAllPreviousVersionForms(formCode).then((res) => {
      this.getPreviousVersionFormResponse(res);
      if (res?.data) {
        // toast.success("Previous Versions loaded successfully!");
        this.onLoading(false);
        return;
      } else if (res?.error !== undefined) {
        // toast.error(res.error.response['data']);
        // toast.error("Could not load previous versions, " + res.error);
        this.onLoading(false);
        return;
      } else {
        // toast.error("Could not be load previous versions due to errors!");
        this.onLoading(false);
        return;
      }
    })
  }

  load = (formId) => {
    currentFormId = formId;
    this.resetState();
    this.loadFormInternal(formId);
  };

  getErrorIds = () => {
    return errorIds;
  };

  saveForm = (formtype) => {
    currentFormId = this.form.id;
    if (this.form !== undefined && currentFormId !== undefined) {
      this.onLoading(true);
      const payload = JSON.parse(JSON.stringify(this.form));
      htmlBase64Utils(payload, true);
      return formBuilderService
        .updateForm(currentFormId, payload)
        .then((res) => {
          this.onLoading(false);
          if (res.error !== undefined) {
            toast.error("Could not save form, " + res.error);
            return res;
          }
          if (formtype === "updateForm") {
            const updatedForm = JSON.parse(JSON.stringify(payload));
            updatedForm["lastUpdatedDate"] = res.data.lastUpdatedDate;
            const DELETE_FIELDS = [
              "business",
              "subbusiness",
              "group",
              "subgroup",
              "retainVersion",
            ];
            DELETE_FIELDS.forEach((field) => delete updatedForm[field]);
            this.onLoadForm(updatedForm, true);
          } else {
            this.onLoadForm(res.data, true);
          }
          let toastMsg;
          if (formtype === "updateForm") {
            toastMsg = "saved";
          } else {
            toastMsg =
              this.form?.formStatus === FORM_STATUS.PUBLISHED
                ? "published"
                : "saved";
          }
          toast.success(`Form ${toastMsg} successfully!`);
          return res;
        });
    }
  };

  getCopyFormResponse = (copyFormRes) => {
    copyResponseState.next(copyFormRes);
  };

  saveCopyForm = () => {
    this.onLoading(true);
    const payload = JSON.parse(JSON.stringify(this.form));
    formBuilderService.copyForm(payload).then((res) => {
      this.getCopyFormResponse(res);
      if (res.data) {
        toast.success("Form copied successfully!");
        this.onLoading(false);
        formListService.fireApi();
        return;
      } else if (res.error !== undefined) {
        // toast.error(res.error.response['data']);
        toast.error("Could not save form, " + res.error);
        this.onLoading(false);
        return;
      } else {
        toast.error("Form could not be created due to errors!");
        this.onLoading(false);
        return;
      }
    });
  };

  getFormDetails = (key, value) => {
    this.formDetails[key] = value;
  };

  resetFormDetails = () => {
    this.formDetails = getInitialFormDetails();
  };

  getFormCategoryDetails = (key, value, options) => {
    if (options.length > 0) {
      const currentItem = options.find((each) => each.categoryName === value);
      if (currentItem) {
        this.formDetails[key] = currentItem.id;
      }
    } else {
      this.formDetails[key] = "";
    }
  };

  sendFormDetails = () => {
    return this.formDetails;
  };

  updateFormStatus = (status) => {
    this.form.formStatus = status;
  };

  openSection = (id) => {
    inputEle = [];
    activeTocElementState.next(undefined);
    expandedSectionId = expandedSectionId !== id ? id : undefined;
    openSectionState.next(expandedSectionId);
  };

  openTranslateSection = (id) => {
    activeTocElementState.next(undefined);
    translateSectionId = translateSectionId !== id ? id : undefined;
    openTranslateSectionState.next(translateSectionId);
  };

  showDialog = (open) => {
    dialogState.next(open);
  };

  toggleTocDrawer = (open, elementId) => {
    sideTocState.next(open);
    activeTocElementState.next(elementId);
  };

  loadInitialFormState = () => {
    formState.next(this.initialForm);
    this.form = JSON.parse(JSON.stringify(this.initialForm));
  };

  updateFormDetails = (key, value) => {
    key = key === "language" ? "defaultLanguageCode" : key;
    this.form[key] = value;
  };

  updateFormCategories = (name, value, existedValues) => {
    const normalize = (str) => str?.toLowerCase().replace(/-/g, "");
    const matchKey = normalize(name);

    let newId = null;
    let newCategoryName = null;
    if (Array.isArray(existedValues) && existedValues.length > 0) {
      const currentItem = existedValues.find(
        (each) => each.categoryName === value,
      );
      if (currentItem) {
        newId = currentItem.id;
        newCategoryName = currentItem.categoryName;
      }
    }

    // Only update form state if a valid match is found
    if (newId !== null && newCategoryName !== null) {
      this.form[name] = newId;

      if (Array.isArray(this.form.formCategories)) {
        this.form.formCategories = this.form.formCategories.map((cat) =>
          normalize(cat.categoryType) === matchKey
            ? { ...cat, id: newId || null, categoryName: newCategoryName }
            : cat,
        );
      }
    }
  };

  updateFormMetaData = (formtype) => {
    // Normalize values from existing formCategories if fields are invalid
    const isValidId = (val) => typeof val === "number" && val > 0;

    const categoriesFromForm = Array.isArray(this.form.formCategories)
      ? this.form.formCategories
      : [];

    const fallbackIfMissing = () => {
      categoriesFromForm.forEach((cat) => {
        switch (cat.categoryType) {
          case "Business":
            if (!isValidId(this.form.business)) this.form.business = cat.id;
            break;
          case "Sub-Business":
            if (!isValidId(this.form.subbusiness))
              this.form.subbusiness = cat.id;
            break;
          case "Group":
            if (!isValidId(this.form.group)) this.form.group = cat.id;
            break;
          case "Sub-Group":
            if (!isValidId(this.form.subgroup)) this.form.subgroup = cat.id;
            break;
          default:
            break;
        }
      });
    };

    fallbackIfMissing();

    // Build clean formCategories with only valid values
    const formCategories = [];

    if (isValidId(this.form.business)) {
      formCategories.push({
        id: this.form.business,
        categoryType: "Business",
        categoryName: this.form.formCategories.find(
          (x) => x.categoryType === "Business" && x.id === this.form.business,
        )?.categoryName,
      });
    }

    if (isValidId(this.form.subbusiness)) {
      formCategories.push({
        id: this.form.subbusiness,
        categoryType: "Sub-Business",
        categoryName: this.form.formCategories.find(
          (x) =>
            x.categoryType === "Sub-Business" && x.id === this.form.subbusiness,
        )?.categoryName,
      });
    }

    if (isValidId(this.form.group)) {
      formCategories.push({
        id: this.form.group,
        categoryType: "Group",
        categoryName: this.form.formCategories.find(
          (x) => x.categoryType === "Group" && x.id === this.form.group,
        )?.categoryName,
      });
    }

    if (isValidId(this.form.subgroup)) {
      formCategories.push({
        id: this.form.subgroup,
        categoryType: "Sub-Group",
        categoryName: this.form.formCategories.find(
          (x) => x.categoryType === "Sub-Group" && x.id === this.form.subgroup,
        )?.categoryName,
      });
    }

    this.form.formCategories = formCategories;
    if (this.form.title) this.form.title = this.form.title.trim();

    if (formtype === "updateForm") {
      this.form.retainVersion = true;
      this.saveForm(formtype);
    } else if (formtype === "copyForm") {
      this.saveCopyForm();
    }

    this.showDialog(false);
  };

  resetDescendantCategories = (resetCategoryType) => {
    const hierarchy = ["Business", "Sub-Business", "Group", "Sub-Group"];

    const typeMap = {
      business: "Business",
      subbusiness: "Sub-Business",
      group: "Group",
      subgroup: "Sub-Group",
    };

    const normalizedType = typeMap[resetCategoryType.toLowerCase()];
    if (!normalizedType) {
      console.warn(`Unknown category type '${resetCategoryType}'`);
      return;
    }

    const resetIndex = hierarchy.indexOf(normalizedType);
    if (resetIndex === -1) return;

    const categoriesToReset = hierarchy.slice(resetIndex + 1);

    categoriesToReset.forEach((cat) => {
      const key = cat.toLowerCase().replace("-", "");
      this.form[key] = "";
    });

    if (Array.isArray(this.form.formCategories)) {
      this.form.formCategories = this.form.formCategories.map((category) =>
        categoriesToReset.includes(category.categoryType)
          ? { ...category, id: null, categoryName: "" }
          : category,
      );
    }
  };

  makeActive = (id) => {
    activeElementId = activeElementId !== id ? id : undefined;
    activeElementState.next(activeElementId);
  };

  makeActiveTranslateSection = (id) => {
    activeTranslateElementId = activeTranslateElementId !== id ? id : undefined;
    activeTranslateElementState.next(activeTranslateElementId);
  };

  openSubSection = (id) => {
    activeTocElementState.next(undefined);
    currentSubsectionId = currentSubsectionId !== id ? id : undefined;
    currentSubsectionState.next(currentSubsectionId);
  };

  openTranslateSubsection = (id) => {
    translateSubsectionId = translateSubsectionId !== id ? id : undefined;
    translateSubsectionState.next(translateSubsectionId);
  };

  changeElement = (id, newType) => {
    var updated = FormHelperService.changeElement(this.form, id, newType);
    if (updated) {
      this.onLoadForm(updated);
    }
  };

  getSections = () => {
    return this.form.children;
  };

  getSubSections = (elementId) => {
    if (this.form.children) {
      sections = this.form.children.filter(function (section) {
        return section.elementId === elementId;
      });
      sectionArray = sections[0].children;
      subsectionArray = sectionArray.filter(function (subsection) {
        return subsection.componentType === "subsection";
      });
      return subsectionArray;
    }
  };

  getQuestionElements = (elementId) => {
    if (elementId && sectionArray) {
      subsections = sectionArray.filter(function (subsection) {
        return subsection.elementId === elementId;
      });
      questionElements = subsections[0].children;
    } else {
      if (sectionArray) {
        questionArray = sectionArray.filter(function (question) {
          return question.componentType !== "subsection";
        });
        questionElements = questionArray;
      }
    }
    return questionElements;
  };

  addSection = (prefix = false, isNotUpdated) => {
    var addedSection = FormHelperService.addNewSectionToForm(
      expandedSectionId,
      this.form,
      prefix,
    );
    var newElement = FormHelperService.addNewElementTo(
      this.form,
      addedSection,
      "text",
    );
    FormHelperService.hydrateElementUniversalTagging(addedSection, this.form);
    FormHelperService.hydrateElementUniversalTagging(newElement, this.form);
    this.openSection(addedSection.elementId);
    this.onLoadForm(this.form, isNotUpdated);
    expandedSectionId = addedSection.elementId;
    activeElementId = newElement.elementId;
  };

  copySection(existedSection) {
    FormHelperService.copySection(this.form, existedSection);
    this.onLoadForm(this.form);
  }

  addSubSection = () => {
    if (expandedSectionId !== undefined) {
      var element = FormHelperService.addNewElementToActiveSection(
        this.form,
        expandedSectionId,
        "subsection",
      );
      if (element) {
        var newElement = FormHelperService.addNewElementToActiveSection(
          this.form,
          expandedSectionId,
          "text",
          element.elementId,
        );
        FormHelperService.hydrateElementUniversalTagging(element, this.form);
        FormHelperService.hydrateElementUniversalTagging(newElement, this.form);
        this.onLoadForm(this.form);
        const elementId = element.elementId;
        this.openSubSection(elementId);
        this.makeActive(elementId);
      }
    }
  };

  copySubSection = (
    selectedSectionId,
    selectedSubsection,
    selectedQuestion,
    copySubsection,
    position,
  ) => {
    if (selectedSectionId !== undefined) {
      var copiedElement = FormHelperService.addCopiedElementtoSelectedSection(
        this.form,
        selectedSectionId,
        selectedSubsection,
        selectedQuestion,
        copySubsection,
        position,
        expandedSectionId,
        currentSubsectionId,
      );
      if (copiedElement) {
        this.onLoadForm(this.form);
      }
    }
  };

  copyQuestion = (
    selectedSectionId,
    selectedSubsection,
    selectedQuestion,
    question,
    position,
    type,
  ) => {
    if (selectedSectionId !== undefined) {
      var copiedQuestion = FormHelperService.copyOrMoveElementtoSelectedSection(
        this.form,
        selectedSectionId,
        selectedSubsection,
        selectedQuestion,
        question,
        position,
        expandedSectionId,
        currentSubsectionId,
        type,
      );
      if (copiedQuestion) {
        this.onLoadForm(this.form);
      }
    }
  };

  moveQuestion = (
    selectedSectionId,
    selectedSubsection,
    selectedQuestion,
    question,
    position,
    type,
  ) => {
    if (selectedSectionId !== undefined) {
      var selectedElement =
        FormHelperService.copyOrMoveElementtoSelectedSection(
          this.form,
          selectedSectionId,
          selectedSubsection,
          selectedQuestion,
          question,
          position,
          expandedSectionId,
          currentSubsectionId,
          type,
        );
      if (selectedElement) {
        this.onLoadForm(this.form);
      }
      this.makeActive(undefined);
    }
  };

  addElement = (type, subsectionId) => {
    if (expandedSectionId === undefined) {
      //If no section expanded then make last one
      if (this.form !== undefined && this.form.children.length > 0) {
        const lastSection = this.form.children[this.form.children.length - 1];
        this.openSection(lastSection.elementId);
      }
    }

    if (expandedSectionId !== undefined && type !== undefined) {
      var element = FormHelperService.addNewElementToActiveSection(
        this.form,
        expandedSectionId,
        type,
        subsectionId,
      );
      if (element) {
        FormHelperService.hydrateElementUniversalTagging(element, this.form);
        this.onLoadForm(this.form);
        const elementId = element.elementId;
        this.makeActive(elementId);
      }
    }
  };

  deleteSection = (selectedSection) => {
    FormHelperService.removeSection(this.form, selectedSection);
    this.onLoadForm(this.form);
    if (selectedSection.elementId === expandedSectionId) {
      this.openSection(undefined);
    }
  };

  deleteSubsection = (selectedSubsection) => {
    FormHelperService.removeSubsectionFromSection(
      this.form,
      expandedSectionId,
      selectedSubsection,
    );
    this.onLoadForm(this.form);
    if (selectedSubsection.elementId === currentSubsectionId) {
      this.openSubSection(undefined);
    }
  };

  deleteElement = (deleteEle, subsectionId) => {
    FormHelperService.removeElementFromSection(
      this.form,
      expandedSectionId,
      deleteEle,
      subsectionId,
    );
    this.onLoadForm(this.form);
    if (currentSubsectionId && !subsectionId) {
      this.openSubSection(undefined);
    }
    this.makeActive(undefined);
  };

  getQuestionsList() {
    return FormHelperService.getQuestionsList(this.form, activeElementId);
  }

  selectedAction(optionId) {
    return FormHelperService.selectedActionForOption(
      this.form,
      expandedSectionId,
      activeElementId,
      currentSubsectionId,
      optionId,
    );
  }

  getConditional() {
    return FormHelperService.getConditionalfromForm(
      this.form,
      expandedSectionId,
      activeElementId,
      currentSubsectionId,
    );
  }

  saveOptionQuestions(optionId, targets, conditional) {
    FormHelperService.saveOptionQuestions(
      this.form,
      expandedSectionId,
      activeElementId,
      currentSubsectionId,
      optionId,
      targets,
      conditional,
    );
  }

  loadFormInternal = (formId) => {
    currentFormId = formId;
    this.onLoading(true);
    if (isMockFlow) {
      this.initializeForm(mockForm);
      return;
    }
    if (currentFormId === undefined) {
      return;
    }
    formBuilderService
      .getForm(currentFormId)
      .then((res) => {
        this.initializeForm(res.data);
      })
      .finally(() => this.onLoading(false));
  };

  initializeForm = (formInfo) => {
    this.onLoadForm(formInfo, true, true);
    if (formInfo.children && formInfo.children.length === 0) {
      this.addSection(false, true);
    }
  };

  onLoadForm = (formInfo, isNotUpdated, keepLoading, notInitialize) => {
    if (expandedSectionId === undefined) {
      this.openSection(undefined);
    }
    if (currentSubsectionId === undefined) {
      this.openSubSection(undefined);
    }
    if (activeElementId === undefined) {
      this.makeActive(undefined);
    }
    const transformedFormInfo = FormHelperService.addFormCategories(formInfo);
    this.form = transformedFormInfo;
    if (!notInitialize)
      this.initialForm = JSON.parse(JSON.stringify(transformedFormInfo));
    isConditionalFormState.next(
      transformedFormInfo?.formType === CONDITIONAL_FORM.CONDITIONAL,
    );
    const formUniversallyTagged = FormHelperService.checkIfConditionalForm(
      transformedFormInfo?.children,
    );
    this.toggleFormUniversalTaggedState(formUniversallyTagged);
    formState.next(transformedFormInfo);
    !keepLoading && this.onLoading(false);
    if (!isNotUpdated) {
      this.shouldNavigate(true);
    } else {
      this.shouldNavigate(false);
    }
  };

  onLoading = (isLoading) => {
    loaderState.next(isLoading);
  };

  resetState = () => {
    currentFormId = undefined;
    expandedSectionId = undefined;
    activeElementId = undefined;
    // if(expandedSectionId == undefined){
    //   openSectionState.next(undefined);
    // }
  };

  shouldNavigate = (isEdited) => {
    routeState.next(isEdited);
  };

  checkFormValid = (isValid) => {
    formValidState.next(isValid);
  };

  //Attributes-related functions:

  addOptions(options) {
    FormHelperService.addOptions(
      this.form,
      expandedSectionId,
      activeElementId,
      currentSubsectionId,
      options,
    );
  }

  addRadioGroupOptions(options, conditionals) {
    FormHelperService.addRadioGroupOptions(
      this.form,
      expandedSectionId,
      activeElementId,
      currentSubsectionId,
      options,
      conditionals,
    );
  }

  addHelpText(helpText) {
    FormHelperService.addHelpText(
      this.form,
      expandedSectionId,
      activeElementId,
      currentSubsectionId,
      helpText,
    );
  }

  addPopupOptions(popupOptions) {
    FormHelperService.addPopupOptions(
      this.translateForm,
      translateSectionId,
      activeTranslateElementId,
      translateSubsectionId,
      popupOptions,
    );
  }

  addDependentDropdownOptions(dynamicDropdownList) {
    FormHelperService.addDependentDropdownOptions(
      this.form,
      expandedSectionId,
      activeElementId,
      currentSubsectionId,
      dynamicDropdownList,
    );
  }

  toggleQuestionAttr(value) {
    FormHelperService.toggleQuestionAttr(
      this.form,
      expandedSectionId,
      activeElementId,
      currentSubsectionId,
      value,
    );
    this.onLoadForm(this.form);
  }

  assignUniqueCodeToQuestion(value) {
    FormHelperService.assignUniqueCodeToQuestion(
      this.form,
      expandedSectionId,
      activeElementId,
      currentSubsectionId,
      value,
    );
    this.onLoadForm(this.form);
  }

  assignLinkedPromptToQuestion(value) {
    FormHelperService.assignLinkedPromptToQuestion(
      this.form,
      expandedSectionId,
      activeElementId,
      currentSubsectionId,
      value,
    );
    this.onLoadForm(this.form);
  }

  deleteUniqueCodeFromQuestion() {
    FormHelperService.deleteUniqueCodeFromQuestion(
      this.form,
      expandedSectionId,
      activeElementId,
      currentSubsectionId,
    );
    this.onLoadForm(this.form);
  }

  deleteLinkedPromptFromQuestion() {
    FormHelperService.deleteLinkedPromptFromQuestion(
      this.form,
      expandedSectionId,
      activeElementId,
      currentSubsectionId,
    );
    this.onLoadForm(this.form);
  }

  //Validations-related functions:
  addErrorId(elementId) {
    if (errorIds.indexOf(elementId) === -1) errorIds.push(elementId);
  }

  deleteErrorId(elementId) {
    if (errorIds.indexOf(elementId) !== -1) {
      let index = errorIds.indexOf(elementId);
      errorIds.splice(index, 1);
    }
  }

  //Conditionals
  showConditionalsMenu = (index) => {
    conditionalMenuIndex = index;
    conditionalMenuState.next(conditionalMenuIndex);
  };

  hideConditionalsMenu = () => {
    conditionalMenuIndex = -1;
    conditionalMenuState.next(conditionalMenuIndex);
  };

  addActionsForOption = (optionId, actions) => {
    FormHelperService.addConditionalsForOption(
      this.form,
      expandedSectionId,
      activeElementId,
      currentSubsectionId,
      optionId,
      actions,
    );
    this.onLoadForm(this.form);
  };

  conditionalsFor = (optionId) => {
    if (optionId === undefined || optionId === null) {
      return null;
    }
    return FormHelperService.conditionalsFor(
      this.form,
      expandedSectionId,
      activeElementId,
      currentSubsectionId,
      optionId,
    );
  };

  actionsForOption = (id) => {
    const conditionals = this.conditionalsFor(id);
    if (conditionals) {
      return conditionals.actions ? conditionals.actions : [];
    }
    return [];
  };

  updateElementProperties(name, value) {
    FormHelperService.updateElementProperties(
      this.form,
      expandedSectionId,
      activeElementId,
      currentSubsectionId,
      name,
      value,
    );
  }

  updateElementRef(elementId, ref) {
    if (ref) {
      inputEle[elementId] = ref;
    }
  }

  getElementRef(elementId) {
    return inputEle[elementId];
  }

  // save-transalte-form //
  sendTranslateForm(translateFormInfo, translationToCode) {
    this.translateForm = translateFormInfo;
    this.translateForm.defaultLanguageCode = translationToCode;
    translateFormState.next(translateFormInfo);
  }

  populateTranslatedFormTitle(formTitle) {
    this.translateForm = { ...this.translateForm, title: formTitle };
  }

  saveTranslateForm = () => {
    if (this.translateForm !== undefined && currentFormId !== undefined) {
      this.onLoading(true);
      translationFormPayloadFormat(this.translateForm);
      const payload = transformFormData(this.translateForm);
      formBuilderService.saveTranslation(payload).then((res) => {
        this.onLoading(false);
        if (res.error !== undefined) {
          toast.error("Could not translate form, " + res.error);
          return;
        }
        toast.success("Form translated successfully!");
        let formId = res.data;
        this.load(formId);
        return res;
      });
    }
  };

  editPublishedForm = (isLastUpdatedVersion) => {
    publishedFormState.next(isLastUpdatedVersion);
  };

  getOptionalEquipment = (optionalEquipment) => {
    optionalEquipmentState.next(optionalEquipment);
  };

  getAllSitesByRegionIds = (regions) => {
    let siteArray = [];
    regionArray = regions.map((region) => {
      fetchSites(region.siteGroupId).then((site) => {
        siteArray.push({
          regionId: region.siteGroupId,
          siteArray: site,
        });
        this.getAllSitesArray(siteArray);
      });
      return region.siteGroupId;
    });
  };

  getAllSitesArray = (siteArray) => {
    if (regionArray.length === siteArray.length) {
      siteArrayState.next(siteArray);
    }
  };

  updateLoggingState = (state) => {
    loggedInState.next(state);
  };

  parentDropDownId = (parentSelectedObject) => {
    parentDropDownId.next(parentSelectedObject);
  };

  SaveAsDraft = (status) => {
    this.updateFormStatus(status);
    let errorIds = this.getErrorIds();
    if (errorIds.length !== 0) {
      toast.error("Form could not be saved due to errors in your form.");
    } else {
      this.saveForm();
    }
  };

  addHelpImage(image) {
    let images = FormHelperService.addHelpImage(
      this.form,
      expandedSectionId,
      activeElementId,
      currentSubsectionId,
      image,
    );
    this.onLoadForm(this.form);
    return images;
  }

  removeHelpImage(imageId) {
    let images = FormHelperService.removeHelpImage(
      this.form,
      expandedSectionId,
      activeElementId,
      currentSubsectionId,
      imageId,
    );
    this.onLoadForm(this.form);
    return images;
  }

  removeAllHelpImage() {
    let images = FormHelperService.removeAllHelpImage(
      this.form,
      expandedSectionId,
      activeElementId,
      currentSubsectionId,
    );
    this.onLoadForm(this.form);
    return images;
  }

  getformType = (formType) => {
    formTypeState.next(formType);
  };

  setFormType = (value) => {
    this.form.formType = value;
  };

  setUpdatedUniversalHierarchy = (hierarchyData) => {
    this.form.universalHierarchy = hierarchyData;
  };

  attachUniversalTaggingToForm(
    children,
    elementId,
    universalTagging,
    selectAllChecked,
  ) {
    children?.forEach((child) => {
      if (child.elementId === elementId) {
        child["universalTagging"] = universalTagging;
        child["allHierarchySelected"] = selectAllChecked;
        return;
      }
      this.attachUniversalTaggingToForm(
        child.children,
        elementId,
        universalTagging,
        selectAllChecked,
      );
    });
  }

  addUniversalTagging(elementId, universalTagging, selectAllChecked) {
    this.attachUniversalTaggingToForm(
      this.form.children,
      elementId,
      universalTagging,
      selectAllChecked,
    );
  }

  applyToSubtree(children, universalTagging, selectAllChecked) {
    children.forEach((child) => {
      child.universalTagging = universalTagging;
      child.allHierarchySelected = selectAllChecked;
      child.conditionalSelected = false;
      if (child.children?.length) {
        this.applyToSubtree(child.children, universalTagging, selectAllChecked);
      }
    });
  }

  updateUniversalTaggingInForm(
    children,
    elementId,
    universalTagging,
    selectAllChecked,
  ) {
    children.forEach((child) => {
      if (child.elementId === elementId) {
        child.universalTagging = universalTagging;
        child.allHierarchySelected = selectAllChecked;
        child.conditionalSelected = false;
        if (child.children?.length) {
          this.applyToSubtree(
            child.children,
            universalTagging,
            selectAllChecked,
          );
        }
      } else {
        if (child.children?.length) {
          this.updateUniversalTaggingInForm(
            child.children,
            elementId,
            universalTagging,
            selectAllChecked,
          );
        }
      }
    });
  }

  updateUniversalTagging(elementId, universalTagging, selectAllChecked) {
    this.updateUniversalTaggingInForm(
      this.form.children,
      elementId,
      universalTagging,
      selectAllChecked,
    );
    this.onLoadForm(this.form, true, true, true);
  }

  initializeUniversalTagging() {
    function traverseAndCopy(initialNode, targetNode) {
      if (initialNode.allHierarchySelected !== undefined) {
        targetNode.allHierarchySelected = initialNode.allHierarchySelected;
      }
      if (initialNode.universalTagging !== undefined) {
        targetNode.universalTagging = [...initialNode.universalTagging];
      }
      if (initialNode.children && targetNode.children) {
        for (let i = 0; i < initialNode.children.length; i++) {
          traverseAndCopy(initialNode.children[i], targetNode.children[i]);
        }
      }
    }
    traverseAndCopy(this.initialForm, this.form);
  }

  detachUniversalTaggingFromForm(children) {
    children?.forEach((child) => {
      delete child.universalTagging;
      delete child.allHierarchySelected;
      child.conditionalSelected = true;
      if (child?.children?.length)
        this.detachUniversalTaggingFromForm(child?.children);
    });
  }

  removeUniversalTagging() {
    this.detachUniversalTaggingFromForm(this.form.children);
    this.onLoadForm(this.form, true, true, true);
  }

  toggleFormUniversalTaggedState = (selected) => {
    formUniversalTaggedState.next(selected);
  };
}

export {
  FormStore,
  formState,
  loaderState,
  routeState,
  formValidState,
  showAlertState,
  openSectionState,
  openTranslateSectionState,
  translateSubsectionState,
  activeElementState,
  currentSubsectionState,
  conditionalMenuState,
  dialogState,
  sideTocState,
  activeTocElementState,
  activeTranslateElementState,
  translateFormState,
  publishedFormState,
  copyResponseState,
  optionalEquipmentState,
  siteArrayState,
  loggedInState,
  parentDropDownId,
  formTypeState,
  isConditionalFormState,
  formUniversalTaggedState,
  previousVersionResponseState,
};

const mockForm = {
  id: 2,
  formCode: 230,
  version: 1,
  title: "New Form - 1",
  assetType: "asset",
  formStatus: "Draft",
  description: "form Description",
  createdBy: "GE Test user 4",
  createdDate: 1589959036531,
  lastUpdatedBy: "GE Test user 4",
  lastUpdatedDate: 1589959036531,
  keywords: ["renewables"],
  children: [
    {
      id: 1,
      order: 1,
      elementId: "5b9c0711-1d75-4253-8ff8-11f3ef62f48b",
      componentType: "section",
      name: "section_id_1",
      label: "General Information",
      buttonIcon: "fa fa-window-maximize",
      buttonName: "Section",
      optionsLabel: "Section",
      enabledActions: ["show", "hide"],
      enabledConditions: [],
      children: [
        {
          id: 8,
          motherId: 1,
          order: 2,
          elementId: "a0f6cc33-ea9d-4185-95dd-a2547f6b336d",
          componentType: "textarea",
          name: "text_area_id_1",
          label: "Text Area Label",
          dataType: "string",
          buttonIcon: "fa fa-font",
          buttonName: "Text",
          optionsLabel: "Text",
          enabledActions: [],
          enabledConditions: [],
          children: [],
          businessUnit: "ren",
        },
        {
          componentType: "radio",
          name: "radio_id_1",
          elementId: "a0f6cc33-ea9d-4185-95dd-qeqeqeqeqe",
          label: "Radio Group Label",
          dataType: "string",
          buttonName: "Radio Button",
          optionsLabel: "Radio Button",
          enabledActions: [],
          enabledConditions: [],
          children: [],
          businessUnit: "ren",
          options: ["Option Label", "Option Label"],
          validations: { required: false },
          properties: {
            visible: true,
            disabled: false,
            answerLabel: "",
            allowFileUpload: false,
          },
        },
      ],
    },
    {
      id: 2,
      order: 2,
      elementId: "5b9c0711-1d75-4253-8ff8-11f3ef634743",
      componentType: "section",
      name: "section_id_1",
      label: "Additional Information",
      buttonIcon: "fa fa-window-maximize",
      buttonName: "Section",
      optionsLabel: "Section",
      enabledActions: ["show", "hide"],
      enabledConditions: [],
      children: [
        {
          id: 8,
          motherId: 2,
          order: 2,
          elementId: "a0f6cc33-ea9d-4185-95dd-a2547f6b34564",
          componentType: "text",
          name: "text_id_1",
          label: "Text Field Label",
          dataType: "string",
          buttonIcon: "fa fa-font",
          buttonName: "Text",
          optionsLabel: "Text",
          enabledActions: [],
          enabledConditions: [],
          children: [],
          businessUnit: "ren",
        },
      ],
    },
  ],
  requests: [],
  responses: null,
  formCategories: [1],
  enforceOrder: null,
  copiedFromFormCode: null,
  copiedFromFormVersion: null,
  customFormCode: null,
  isInLine: false,
  formSupportedLanguages: [],
  defaultLanguageCode: "en",
  componentType: "form",
  hashCode: -448201537,
};
